module.exports = __webpack_public_path__ + "img/down-gansu1.c3a59321.jpg";